"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TeachingPopover: function() {
        return _TeachingPopover.TeachingPopover;
    },
    renderTeachingPopover_unstable: function() {
        return _renderTeachingPopover.renderTeachingPopover_unstable;
    },
    useTeachingPopover_unstable: function() {
        return _useTeachingPopover.useTeachingPopover_unstable;
    }
});
const _TeachingPopover = require("./TeachingPopover");
const _renderTeachingPopover = require("./renderTeachingPopover");
const _useTeachingPopover = require("./useTeachingPopover");
